import { LitigationUnion } from "../../../../types/LitigationUnion";
import { OrganizationEmail } from "../../../../types/OrganizationEmail";
import * as stagesCase from "../../../Stages/StagesCase";
import _ from "lodash";
import { AutoCompleteOptionWithValue } from "../../../../types/AutoCompleteOptionWithValue";

export const debtCollectionAgencyFields = (product: LitigationUnion) => {
  return {
    isHidden: ({ product }: { product: LitigationUnion }) =>
      product.stage! < stagesCase.STAGE_DATA_COMPLETED ||
      !_.includes(["defendClaim", "enforceClaim"], product.caseCategory),
    label: "Inkassobüro",
    elements: [
      {
        type: "DebtCollectionAgencyPicker",
        path: `${product.productClassName}.debtCollectionAgency.organization`,
        isDisabled: ({ product }: { product: LitigationUnion }) => product.stage! >= stagesCase.STAGE_COMPLETED,
        additionalProps: {
          fullWidth: true,
        },
      },
      {
        type: "ValidatorTextField",
        path: `${product.productClassName}.debtCollectionAgencyReference`,
      },
      {
        type: "ValidatorAutoComplete",
        path: `${product.productClassName}.debtCollectionAgency.organizationEmail`,
        additionalProps: {
          // do not remove this empty function, this overrides the default onInputChange={e}
          // which is breaking this autocomplete because the valid values are in the options/selector and
          // should not simply be added from the input field because its not a valid iri
          onInputChange: () => {},
          clearOnBlur: true,
          isOptionEqualToValue: (option: AutoCompleteOptionWithValue, value: AutoCompleteOptionWithValue) =>
            option.value === value.value,
          extractNewValue: (newValue: AutoCompleteOptionWithValue) => (newValue ? newValue.value : null),
          getSelectedValue: (options: AutoCompleteOptionWithValue[], value: AutoCompleteOptionWithValue) =>
            options.find((opt: AutoCompleteOptionWithValue) => opt.value === value) || null,
          options: ({ product }: { product: LitigationUnion }) => {
            return (
              product.debtCollectionAgency?.organization.availableEmails.map(
                (organizationEmail: OrganizationEmail) => ({
                  label: organizationEmail.email,
                  value: organizationEmail["@id"],
                }),
              ) || []
            );
          },
        },
      },
    ],
  };
};
